// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publish-dialog {
  min-width: 280px;
  max-width: 420px;
  padding: 4px 4px 8px;
  color: #1a1a1a;
}

.publish-dialog h5 {
  margin: 0 0 12px;
  font-size: 1rem;
  color: #1a1a1a;
}

.publish-scope {
  display: grid;
  gap: 6px;
  margin-bottom: 16px;
}

.publish-scope__label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
}

.publish-scope__select {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #d0d0d0;
  background: #fff;
  color: #1a1a1a;
  font: inherit;
}

.publish-scope__hint {
  margin: 0;
  font-size: 0.8rem;
  color: #555;
}

.publish-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
}

:host-context(body.theme-dark) .publish-dialog,
:host-context(body.theme-dark) .publish-dialog h5 {
  color: #f8fafc;
}
:host-context(body.theme-dark) .publish-scope__label {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .publish-scope__select {
  background: #0f172a;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .publish-scope__hint {
  color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/publish-dialog/publish-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,QAAA;AACF;;AAGE;;EAEE,cAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAFJ;AAKE;EACE,cAAA;AAHJ","sourcesContent":[".publish-dialog {\n  min-width: 280px;\n  max-width: 420px;\n  padding: 4px 4px 8px;\n  color: #1a1a1a;\n}\n\n.publish-dialog h5 {\n  margin: 0 0 12px;\n  font-size: 1rem;\n  color: #1a1a1a;\n}\n\n.publish-scope {\n  display: grid;\n  gap: 6px;\n  margin-bottom: 16px;\n}\n\n.publish-scope__label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.publish-scope__select {\n  width: 100%;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #d0d0d0;\n  background: #fff;\n  color: #1a1a1a;\n  font: inherit;\n}\n\n.publish-scope__hint {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #555;\n}\n\n.publish-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 4px;\n}\n\n:host-context(body.theme-dark) {\n  .publish-dialog,\n  .publish-dialog h5 {\n    color: #f8fafc;\n  }\n\n  .publish-scope__label {\n    color: #e2e8f0;\n  }\n\n  .publish-scope__select {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .publish-scope__hint {\n    color: #94a3b8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
